var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticStyle:{"height":"100vh"},attrs:{"column":"","justify-center":"","align-center":""}},[(_vm.progress)?_c('v-progress-circular',{attrs:{"width":"8","size":90,"color":"primary","indeterminate":_vm.progress}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }